import fire from "./fire";

export async function getKnowledgeById(itemid) {
  const db = fire.firestore();

  return await db.collection("knowledge").where("itemid", "==", itemid).get();
}
